// ========================================
// Subject Service
// Handles all subject-related operations
// ========================================

const SubjectService = {
    /**
     * Get all subjects
     */
    getSubjects() {
        return DataManager.getAll(DataManager.KEYS.SUBJECTS);
    },

    /**
     * Get subject by ID
     */
    getSubject(id) {
        return DataManager.getById(DataManager.KEYS.SUBJECTS, id);
    },

    /**
     * Get subjects by formation
     */
    getSubjectsByFormation(formationId) {
        return this.getSubjects().filter(s => s.formationId === formationId);
    },

    /**
     * Get subjects by professor
     */
    getSubjectsByProfessor(professorId) {
        return this.getSubjects().filter(s => s.professorId === professorId);
    },

    /**
     * Create new subject
     */
    createSubject(data) {
        const subject = {
            id: Utils.generateUUID(),
            name: data.name,
            formationId: data.formationId,
            professorId: data.professorId || null,
            color: data.color || '#FFD700',
            description: data.description || '',
            totalHours: (typeof data.totalHours === 'number' && !isNaN(data.totalHours)) ? data.totalHours : (parseInt(data.totalHours) || 0),
            studyBlock: data.studyBlock || 'OTROS', // To categorize in the Study Plan (LENGUA, PROTOCOLOS, etc)
            defaultStartTime: data.defaultStartTime || null,
            defaultEndTime: data.defaultEndTime || null,
            type: data.type || 'COMÚN',
            createdAt: new Date().toISOString()
        };
        return DataManager.add(DataManager.KEYS.SUBJECTS, subject);
    },

    /**
     * Update subject
     */
    updateSubject(id, data) {
        return DataManager.update(DataManager.KEYS.SUBJECTS, id, data);
    },

    /**
     * Delete subject and all related classes
     */
    deleteSubject(id) {
        // Delete all classes for this subject
        const classes = DataManager.getAll(DataManager.KEYS.CLASSES);
        const updatedClasses = classes.filter(c => c.subjectId !== id);
        DataManager.saveAll(DataManager.KEYS.CLASSES, updatedClasses);

        return DataManager.delete(DataManager.KEYS.SUBJECTS, id);
    },

    /**
     * Get subject with all its classes
     */
    getSubjectWithClasses(id) {
        const subject = this.getSubject(id);
        if (!subject) return null;

        const classes = DataManager.getAll(DataManager.KEYS.CLASSES)
            .filter(c => c.subjectId === id);

        return {
            ...subject,
            classes
        };
    },

    /**
     * Get subject statistics
     */
    getSubjectStats(subjectId) {
        const classes = DataManager.getAll(DataManager.KEYS.CLASSES)
            .filter(c => c.subjectId === subjectId);

        let totalWeeklyHours = 0;
        classes.forEach(cls => {
            const duration = Utils.calculateDuration(cls.startTime, cls.endTime);
            totalWeeklyHours += duration;
        });

        return {
            totalClasses: classes.length,
            totalWeeklyHours
        };
    },

    /**
     * Assign professor to subject
     */
    assignProfessor(subjectId, professorId) {
        return this.updateSubject(subjectId, { professorId });
    },

    /**
     * Remove professor from subject
     */
    removeProfessor(subjectId) {
        return this.updateSubject(subjectId, { professorId: null });
    }
};

// Make SubjectService globally available
window.SubjectService = SubjectService;
